module.exports = __webpack_public_path__ + "img/11.41f8278a.jpg";